import React from 'react';
import { Button, Checkbox, Input, Spin, Table, Tag } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { usePW030AReport } from './hooks/usePW030AReport';
import type { PW030AReportRow } from '../../services/pw030aApi';
import './PW030AForm.css';

const columns: ColumnsType<PW030AReportRow> = [
  {
    title: '員工代號',
    dataIndex: 'f003_01',
    key: 'f003_01',
    width: 100,
    sorter: (a, b) => a.f003_01.localeCompare(b.f003_01),
  },
  {
    title: '等級代碼',
    dataIndex: 'f003_12',
    key: 'f003_12',
    width: 90,
    sorter: (a, b) => a.f003_12.localeCompare(b.f003_12),
  },
  {
    title: '姓名',
    dataIndex: 'f901_11',
    key: 'f901_11',
    width: 120,
    sorter: (a, b) => a.f901_11.localeCompare(b.f901_11),
  },
  {
    title: '部門',
    dataIndex: 'f901_32',
    key: 'f901_32',
    width: 80,
  },
  {
    title: '到職日',
    dataIndex: 'f901_31',
    key: 'f901_31',
    width: 110,
    render: (v: string) => v || '-',
    sorter: (a, b) => (a.f901_31 || '').localeCompare(b.f901_31 || ''),
  },
  {
    title: '狀態',
    dataIndex: 'f901_34',
    key: 'f901_34',
    width: 80,
    render: (v: string) =>
      v ? (
        <Tag color="red">已離職</Tag>
      ) : (
        <Tag color="green">在職</Tag>
      ),
  },
];

const PW030AForm: React.FC = () => {
  const {
    loading, records, total,
    startGrade, setStartGrade,
    endGrade, setEndGrade,
    excludeDeparted, setExcludeDeparted,
    handleQuery,
  } = usePW030AReport();

  return (
    <Spin spinning={loading}>
      <div className="pw030a-form">
        <h2 style={{ marginBottom: 16 }}>
          等級-人員清冊 — pw030af1
          {total > 0 && (
            <span style={{ marginLeft: 12, fontSize: 14, fontWeight: 400, color: '#1890ff' }}>
              共 {total} 筆
            </span>
          )}
        </h2>

        {/* Filter: Grade range */}
        <div className="filter-row">
          <span className="filter-label">等級代碼：</span>
          <Input
            placeholder="起始"
            value={startGrade}
            onChange={(e) => setStartGrade(e.target.value)}
            style={{ width: 120 }}
          />
          <span className="filter-sep">～</span>
          <Input
            placeholder="結束"
            value={endGrade}
            onChange={(e) => setEndGrade(e.target.value)}
            style={{ width: 120 }}
          />
        </div>

        {/* Filter: Exclude departed */}
        <div className="filter-row">
          <span className="filter-label" />
          <Checkbox
            checked={excludeDeparted}
            onChange={(e) => setExcludeDeparted(e.target.checked)}
          >
            排除已離職人員
          </Checkbox>
        </div>

        {/* Query button */}
        <div className="action-row">
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleQuery}
            loading={loading}
          >
            開始查詢
          </Button>
        </div>

        {/* Results table */}
        <Table<PW030AReportRow>
          columns={columns}
          dataSource={records}
          rowKey={(r) => `${r.f003_01}-${r.f003_12}`}
          pagination={{
            pageSize: 100,
            showSizeChanger: true,
            showTotal: (t) => `共 ${t} 筆`,
          }}
          size="small"
          scroll={{ x: 800 }}
          locale={{ emptyText: '請設定篩選條件後按「開始查詢」' }}
        />
      </div>
    </Spin>
  );
};

export default PW030AForm;
